<template>
  <div id="config-management">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Config Management</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Kelola Konfigurasi Aplikasi</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <!-- start panel heading -->
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Konfig Aplikasi
            </div>
            <div>
              <button class="btn btn-success" style="padding:5px; font-size: 11px;" @click="save()">Simpan</button>
            </div>
          </div>
          <!-- end of panel heading -->
          <!-- start of panel body -->
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-warning"><strong>Perhatian!</strong> Jangan lupa mengklik tombol "Simpan" untuk menyimpan perubahan konfig ke server</div>
                <table class="table table-stripped">
                  <tr v-for="(config, index) in configs" v-bind:key="config.id">
                    <td><strong>{{config.key}}</strong></td>
                    <td>
                      <input v-if="editRow == index" type="text" class="form-control" v-model="editValue">
                      <span v-else>{{config.value}}</span>
                    </td>
                    <td>
                      <span v-if="editRow != index" class="btn btn-primary btn-xs"><i class="fa fa-edit" @click="edit(index)"></i></span>
                      <div v-else>
                        <span class="btn btn-success btn-xs"><i class="fa fa-check" @click="confirm(index)"></i></span>
                        <span class="btn btn-danger btn-xs"><i class="fa fa-times" @click="editRow = -1"></i></span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <!-- end of panel body -->
          <app-spinner v-if="isLoading"></app-spinner>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigService from '@/services/config_service'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'config-management',
  components: {
    'app-spinner': Spinner
  },
  data: function() {
    return {
      configs: [],
      editRow: -1,
      editValue: null,
      isLoading: false
    }
  },
  methods: {
    fetchData: function() {
      var context = this
      ConfigService.getApplicationConfig(function(response) {
        if(response.success) {
          context.configs = response.data
        }
      })
    },
    edit: function(index) {
      this.editRow = index
      this.editValue = this.configs[index].value
    },
    confirm: function(index) {
      this.configs[index].value = this.editValue
      this.editValue = null
      this.editRow = -1
    },
    save: function() {
      var context = this

      this.isLoading = true
      ConfigService.saveApplicationConfig(this.configs, function(response) {
        context.isLoading = false
        alert("Konfig berhasil disimpan")
      })
    }
  },
  mounted: function() {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?4770fb60